// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProtocolVisit
 */
export interface ProtocolVisit {
    /**
     * 
     * @type {string}
     * @memberof ProtocolVisit
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ProtocolVisit
     */
    study_day?: string;
    /**
     * 
     * @type {string}
     * @memberof ProtocolVisit
     */
    study_week?: string;
    /**
     * 
     * @type {string}
     * @memberof ProtocolVisit
     */
    visit_number: string;
    /**
     * 
     * @type {string}
     * @memberof ProtocolVisit
     */
    window_days?: string;
}

/**
 * Check if a given object implements the ProtocolVisit interface.
 */
export function instanceOfProtocolVisit(value: object): value is ProtocolVisit {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('visit_number' in value) || value['visit_number'] === undefined) return false;
    return true;
}

export function ProtocolVisitFromJSON(json: any): ProtocolVisit {
    return ProtocolVisitFromJSONTyped(json, false);
}

export function ProtocolVisitFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProtocolVisit {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'study_day': json['study_day'] == null ? undefined : json['study_day'],
        'study_week': json['study_week'] == null ? undefined : json['study_week'],
        'visit_number': json['visit_number'],
        'window_days': json['window_days'] == null ? undefined : json['window_days'],
    };
}

export function ProtocolVisitToJSON(json: any): ProtocolVisit {
    return ProtocolVisitToJSONTyped(json, false);
}

export function ProtocolVisitToJSONTyped(value?: ProtocolVisit | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'study_day': value['study_day'],
        'study_week': value['study_week'],
        'visit_number': value['visit_number'],
        'window_days': value['window_days'],
    };
}
